import { createContext, FC, ReactNode, useContext } from 'react';

export type ServerVarsContextType = {
    isBot?: boolean; // should be set only for SSR
    isDesktop?: boolean | null;
    isMobile?: boolean | null;
    isSbAdsEnabled?: boolean | null;
    isTablet?: boolean | null;
    clientConf?: { [key: string]: string | number | undefined } | null;
    localeOrigin?: string | null;
    isSearchQueryApplied?: boolean | null;
    locale?: string | null;
    originalUrl?: string | null;
    isSoldPDPV1Variant?: boolean | null;
    isNavigationVariant?: boolean;
    isRespPdpSiderailV1Variant?: boolean;
    isTradeQuickFiltersVariant?: boolean;
    shouldHideL1TopModules?: boolean;
    isMoveSaveSearchVariant?: boolean;
};

export const ServerVarsContext = createContext<ServerVarsContextType>({
    isBot: false,
    isDesktop: null,
    isMobile: null,
    isSbAdsEnabled: null,
    isTablet: null,
    clientConf: {},
    localeOrigin: null,
    locale: null,
    originalUrl: null,
    isSearchQueryApplied: null,
    isNavigationVariant: false,
    isRespPdpSiderailV1Variant: false,
    isTradeQuickFiltersVariant: false,
    shouldHideL1TopModules: false,
    isMoveSaveSearchVariant: false,
});

export const useServerVarsContext = (): ServerVarsContextType =>
    useContext<ServerVarsContextType>(ServerVarsContext);

export const ServerVarsContextConsumer = ServerVarsContext.Consumer;

export const ServerVarsContextProvider: FC<ServerVarsContextType & { children: ReactNode }> = ({
    children,
    isDesktop,
    isMobile,
    isSbAdsEnabled,
    isTablet,
    clientConf,
    localeOrigin,
    originalUrl,
    isSearchQueryApplied,
    locale,
    isSoldPDPV1Variant,
    isBot,
    isNavigationVariant,
    isRespPdpSiderailV1Variant,
    isTradeQuickFiltersVariant,
    shouldHideL1TopModules,
    isMoveSaveSearchVariant,
}) => {
    return (
        <ServerVarsContext.Provider
            value={{
                isDesktop,
                isMobile,
                isSbAdsEnabled,
                isTablet,
                clientConf,
                localeOrigin,
                originalUrl,
                isSearchQueryApplied,
                locale,
                isSoldPDPV1Variant,
                isBot,
                isNavigationVariant,
                isRespPdpSiderailV1Variant,
                isTradeQuickFiltersVariant,
                shouldHideL1TopModules,
                isMoveSaveSearchVariant,
            }}
        >
            {children}
        </ServerVarsContext.Provider>
    );
};
